import * as React from 'react';
import {
  PaginatorAndListSettings,
  Search,
  Section,
  useCacheQuery,
  useCloneEntity,
  useQueryOptionsFromSearchParams,
} from 'gossamer-front-end';
import { InstitutionMemberView } from 'cb-model';
import { QueryOptions } from 'gossamer-unified';
import { useInstitutionFilter } from '../institution/useInstitutionFilter';

export const AdminMemberSearch = (): React.JSX.Element => {
  const initialQueryOptions = useInstitutionFilter({
    where: {
      and: [
        { fieldId: 'institution_id', operator: 'eq', value: '', display: 'hidden' },
        { fieldId: 'email', operator: 'ct', value: '', display: 'value-edit' },
        { fieldId: 'is_admin', operator: 'eq', value: true, display: 'hidden' },
      ],
    },
    order: [['last_name', 'ASC']],
  } as QueryOptions);
  const [queryOptions, setQueryOptions] = useQueryOptionsFromSearchParams(InstitutionMemberView, initialQueryOptions);
  const gCacheQueryItem = useCacheQuery(InstitutionMemberView, queryOptions);
  const LocalUserView = useCloneEntity(InstitutionMemberView, (local) => {
    local.fields.is_admin.listColumn = false;
    local.fields.is_verified.listColumn = false;
  });
  return (
    <Section subtitle="Administrators for this institution">
      <PaginatorAndListSettings
        entity={LocalUserView}
        gCacheQuery={gCacheQueryItem}
        queryOptions={queryOptions}
        render={Search}
        setQueryOptions={setQueryOptions}
      />
    </Section>
  );
};
